// components/ConfirmationModal.tsx
import React from "react";

interface ConfirmationModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  message,
  onConfirm,
  onCancel,
  loading = false,
  confirmText = "Yes",
  cancelText = "No",
}) => {
  return (
    <div
      className="modal fade show"
      tabIndex={-1}
      style={{ display: "block", zIndex: 1055 }}
    >
      <div className="Modal__dialog animated slideInDown" role="document">
        <div className="Modal__content">
          <div className="Modal__body" style={{ overflow: "hidden" }}>
            <p className="d-flex justify-content-center">{message}</p>
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn zoom-element btn login-btn"
                disabled={loading}
                onClick={onConfirm}
              >
                {loading ? "Loading..." : confirmText}
              </button>
              <button
                type="button"
                className="btn zoom-element reject_btn"
                disabled={loading}
                onClick={onCancel}
              >
                {cancelText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
